<template>
  <div>
    <!-- <div class="container">
      <dataPannel></dataPannel>
    </div>

    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="{ labelWidth: 90, itemWidth: 220 }"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div> -->

    <!-- 操作按钮 -->
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="secondary" @click="goDetail('', 'add')">产品碳足迹收集</eui-btn>
      </div>
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel1"
        :index-show="true"
        :row-class-name="getRowClassName"
      >
        <template #handle="{ scope }">
          <eui-btn type="link" font-size="12px" @click="goDetail(scope.row, 'detail')">查看详情</eui-btn>
          <eui-btn type="link" font-size="12px" @click="goDetail(scope.row, 'edit')">编辑</eui-btn>
          <eui-btn type="link" font-size="12px" @click="deleteItem(scope.row)">删除</eui-btn>
        </template>
      </eTableList>

      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <item-edit
      v-if="itemEditVisible"
      :item-data="itemData"
      :visible.sync="itemEditVisible"
      :title="itemTitle"
      @submitPopupData="submitPopupData"
    />
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/carbonfoot';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import itemEdit from './itemEdit.vue';

import { tableLabel1 } from './componentsData.js';

const GREEN_CARBON_REPORT_URL = 'greenCarbonReport';

/** 本页列表仅编辑产品碳足迹（弹框），不含供应商信息 */
const CARBON_REPORT_META = {
  key: 'carbonReportList',
  ref: 'productCarbonFootprint',
};

/** 列表单条详情 → 产品碳足迹组件 report 回显 */
const normalizeListRecordToReportList = (data) => {
  if (!data || typeof data !== 'object') {
    return [];
  }
  if (Array.isArray(data.carbonReportList) && data.carbonReportList.length > 0) {
    return data.carbonReportList;
  }
  return [data];
};

export default {
  components: {
    eTableList,
    itemEdit,
  },
  data() {
    return {
      tableLabel1,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        dataType: '4',
      },
      cloneListQuery: {},
      total: 0,
      tableData: [],
      itemEditVisible: false,
      itemTitle: '',
      itemData: {},
      modelUrl: GREEN_CARBON_REPORT_URL,
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
        }
      },
    },
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },
  methods: {
    getRowClassName({ row }) {
      if (Number(row.checkStatus) === 1) {
        return 'check-status-error';
      }
      return '';
    },
    async submitPopupData({ success, data, id }) {
      if (!success || !id) {
        return;
      }
      const res = await Api.update(
        {
          id,
          ...data,
        },
        this.modelUrl
      );
      if (res.code === '200') {
        this.$message.success('保存成功');
        this.itemEditVisible = false;
        this.getList(this.listQuery);
      }
    },
    async goDetail(row, type) {
      if (type === 'add') {
        this.$router.push({
          path: '/CarbonfootprintManage/CarbonfootprintDetail',
          query: { type },
        });
        return;
      }
      this.itemTitle = type === 'edit' ? '编辑产品碳足迹' : '查看产品碳足迹';
      try {
        const res = await Api.detail({ id: row.id }, this.modelUrl);
        if (res.code === '200' && res.data) {
          this.itemData = {
            ...res.data,
            id: row.id,
            type,
            ref: CARBON_REPORT_META.ref,
            key: CARBON_REPORT_META.key,
            reportList: normalizeListRecordToReportList(res.data),
          };
          this.itemEditVisible = true;
        }
      } catch (e) {
        this.$message.error('获取详情失败，请稍后重试');
      }
    },
    async deleteItem(row) {
      this.$confirm('您确认要删除吗？不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await Api.delete(
          {
            id: row.id,
          },
          this.modelUrl
        );
        if (res.code === '200') {
          this.$message.success('删除成功');
          this.getList(this.listQuery);
        }
      });
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryPage(params, this.modelUrl).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.createTime?.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        val.startTime = '';
        val.endTime = '';
        val.createTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .check-status-error td {
  color: #f5222d;
}
</style>
